enum DesignStyleDataType {
  GET_DESIGN_STYLES_DATA_REQUEST = 'designStyles/getDesignStylesDataRequest',
  GET_DESIGN_STYLES_DATA_REJECTED = 'designStyles/getDesignStylesDataRejected',
  GET_DESIGN_STYLES_DATA_FULFILLED = 'designStyles/getDesignStylesDataFulfilled',
}

export default DesignStyleDataType;
